import "./styles.less";

import { Card, Typography } from "antd";

import { ImagenOptimizada } from "../../Image/web";
import { useSEO } from "../hook";

const { Meta } = Card;
const { Title } = Typography;

export const SeoLandingCard = () => {
	const {
		seoMetaTags: { seoLanding, h1 },
	} = useSEO();

	if (!seoLanding) return null;

	const seoLoadingImage = <ImagenOptimizada src={seoLanding.image} alt={h1} />;
	const seoLoadingTitle = <Title>{h1}</Title>;

	return (
		<Card
			className="card-seo-landing-container"
			title={seoLoadingTitle}
			cover={seoLoadingImage}>
			<Meta description={seoLanding.text} />
		</Card>
	);
};
